import { lazy } from "react"
import { Root } from "src/shared/components"
import PermissionRoute from "../permission-route"
import { Navigate } from "react-router-dom"

// --- Manufacturer Routes ---
const ManufacturersList = lazy(() => import("src/modules/procurement/manufacturers/pages/ManufacturersList"))
const UpdateManufacturer = lazy(() => import("src/modules/procurement/manufacturers/pages/UpdateManufactuer"))
const CreateManufacturer = lazy(() => import("src/modules/procurement/manufacturers/pages/CreateManufacturer"))

// --- Vendor Routes ----
const Vendors = lazy(() => import("src/modules/procurement/vendors/pages/VendorsList"))
const CreateVendor = lazy(() => import("src/modules/procurement/vendors/pages/CreateVendor"))
const UpdateVendor = lazy(() => import("src/modules/procurement/vendors/pages/UpdateVendor"))

// ----- Purchase-Order Routes -----
const PurchaseOrdersList = lazy(() => import("src/modules/procurement/purchase-order/pages/PurchaseOrdersList"))
const CreatePurchaseOrder = lazy(() => import("src/modules/procurement/purchase-order/pages/CreatePurchaseOrder"))

// --- GRN Routes ----
const CreateGRN = lazy(() => import("src/modules/procurement/grn/pages/CreateGRN"))
const GrnList = lazy(() => import("src/modules/procurement/grn/pages/GrnList"))
const GrnDetail = lazy(() => import("src/modules/procurement/grn/pages/GrnListDetail"))

// ---- Stock Return Routes -----
const StockReturnsList = lazy(() => import("src/modules/procurement/stock-return/pages/StockReturnsList"))
const AddStockReturn = lazy(() => import("src/modules/procurement/stock-return/pages/AddStockReturn"))

const procurementRoutes = {
  path: "procurement",
  element: <Root />,
  children: [
    { index: true, element: <Navigate to="/app/procurement/manufacturer" /> },
    {
      path: "manufacturer",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="procurement:manufacturer:read">
              <ManufacturersList />
            </PermissionRoute>
          )
        },
        {
          path: "create",
          element: (
            <PermissionRoute permission="procurement:manufacturer:create">
              <CreateManufacturer />
            </PermissionRoute>
          )
        },
        {
          path: "update/:id",
          element: (
            <PermissionRoute permission="procurement:manufacturer:update">
              <UpdateManufacturer />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "vendor",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission={"procurement:vendor:read"}>
              <Vendors />
            </PermissionRoute>
          )
        },
        {
          path: "create",
          element: (
            <PermissionRoute permission={"procurement:vendor:create"}>
              <CreateVendor />
            </PermissionRoute>
          )
        },
        {
          path: "update/:id",
          element: (
            <PermissionRoute permission={"procurement:vendor:update"}>
              <UpdateVendor />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "purchase-order",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission={"procurement:purchase-order:read"}>
              <PurchaseOrdersList />
            </PermissionRoute>
          )
        },
        {
          path: "create",
          element: (
            <PermissionRoute permission={"procurement:purchase-order:create"}>
              <CreatePurchaseOrder />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "grn",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission={"procurement:goods-receipt-note:read"}>
              <GrnList />
            </PermissionRoute>
          )
        },
        {
          path: "create",
          element: (
            <PermissionRoute permission={"procurement:goods-receipt-note:create"}>
              <CreateGRN />
            </PermissionRoute>
          )
        },
        {
          path: "details/:id",
          element: (
            <PermissionRoute permission={"procurement:goods-receipt-note:details"}>
              <GrnDetail />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "stock-return",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <>
              <PermissionRoute permission={"procurement:stock-return:read"}>
                <StockReturnsList />
              </PermissionRoute>
            </>
          )
        },
        {
          path: "create",
          element: (
            <>
              <PermissionRoute permission={"procurement:stock-return:create"}>
                <AddStockReturn />
              </PermissionRoute>
            </>
          )
        }
      ]
    }
  ]
}
export default procurementRoutes
